import React from "react";
import { Helmet } from "@dr.pogodin/react-helmet";

export const SITE_URL = "https://masjidsuite.com";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/assets/hero-devices.png`;

// Reusable per-page SEO tags: title, description, canonical, Open Graph, Twitter Card.
// Place at the top of every page component with unique title/description/path.
export default function SEO({ title, description, path = "/", image = DEFAULT_OG_IMAGE, noindex = false, jsonLd }) {
  const url = `${SITE_URL}${path}`;
  const jsonLdList = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Masjid Suite" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLdList.map((schema, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(schema)}</script>
      ))}
    </Helmet>
  );
}
